export default __webpack_public_path__ + "static/media/Formular-Bold.592918fa.svg";